import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { FeiertagsausgleichSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/FeiertagsausgleichSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { getTageKeyByValue } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { Body, Heading, Switch } from '@e2n/ui/v2';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Feiertagseinstellungen() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <div className="flex flex-col md:gap-10 gap-6">
      <Heading>{ctx.getCurrentSubStep()?.title}</Heading>
      <div className="flex flex-col gap-6">
        <form.AppField name="abwesenheiten.feiertagseinstellungen.feiertagsdynamik">
          {(field) => (
            <FieldBase>
              <Switch
                id={field.name}
                checked={field.state.value === 'AUF_SOLL_AUFFUELLEN'}
                onCheckedChange={(checked) =>
                  field.handleChange(checked ? 'AUF_SOLL_AUFFUELLEN' : 'KEINE')
                }
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsdynamik.label',
                )}
              />
            </FieldBase>
          )}
        </form.AppField>
        <div className="col-span-2 grid md:grid-cols-2 items-start">
          <FeiertagsausgleichSelect />
        </div>
        <form.Subscribe
          selector={(state) => ({
            arbeitstage: state.values.bezahlung.arbeitszeitkonto.arbeitstage,
            feiertagsausgleich:
              state.values.abwesenheiten.feiertagseinstellungen
                .feiertagsausgleich,
          })}>
          {({ arbeitstage, feiertagsausgleich }) =>
            feiertagsausgleich === 'STUNDENGUTSCHRIFT' &&
            arbeitstage.length > 0 && (
              <div className="flex flex-col gap-2 bg-neutrals-200 rounded-xl py-4 px-5">
                <Body>
                  {t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.info.aufzuwendendeUrlaubstage',
                    { tage: arbeitstage.length },
                  )}
                </Body>
                <div className=" flex gap-1 items-center">
                  <FontAwesomeIcon icon={faArrowRight} />
                  <Body weight={'semibold'}>
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.info.feiertagsAusgleich',
                      {
                        listTage: [...arbeitstage]
                          .sort((a, b) => a - b)
                          .map((tag) =>
                            t('general.date.days.' + getTageKeyByValue(tag)),
                          )
                          .join(', '),
                      },
                    )}
                  </Body>
                </div>
              </div>
            )
          }
        </form.Subscribe>
      </div>
    </div>
  );
}
